<template>
    <!-- <h1>{{ text }}</h1> -->
</template>
<script>
export default {
    data(){
        return {
            text: "Vue3 component."
        }
    },
    mounted() {
        var script = document.createElement('script'); 
        script.src="//cdn.jsdelivr.net/npm/eruda"; 
        document.body.appendChild(script); 
        script.onload = function () { eruda.init() };
    }
}
</script>
